import {Injectable} from '@angular/core';

@Injectable()
export class Globals {
  isUserLoggedIn: boolean;
  isCreateApplication: boolean;
  allApplications: boolean;
}
